module.exports = {
    merchantName: "Maxs kebab",
    merchantDomain: "https://maxskebabshatfield.co.uk",  // Need correct! project will upload dist to targer domain file in Plesk.
    merchantMenuUrl: "/menu-max's-kebabs-chicken-shakes-al10", // target merchant's menu url in alleatapp.com
    // when you building files, fill this info, dont push these to github.
    pleskUsername: 'root',
    pleskPs: '3uyo$9!Ws9',
}
